<template>
  <v-container fluid>
    <v-row class="mb-4 align-center">
      <v-col cols="12" md="6">
        <h1 class="text-h5 font-weight-bold mb-0">Negocios</h1>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-end">
        <v-btn color="primary" to="/platform/businesses/new">
          <v-icon left>mdi-plus</v-icon>
          Nuevo negocio
        </v-btn>
      </v-col>
    </v-row>

    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              label="Buscar"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="loadBusinesses"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="statusFilter"
              :items="statusOptions"
              label="Estado"
              outlined
              dense
              clearable
              hide-details
              @change="loadBusinesses"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="primary" block @click="loadBusinesses">Filtrar</v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-data-table
        :headers="headers"
        :items="businesses"
        :loading="loading"
        :items-per-page="15"
        class="elevation-0"
        @click:row="goToDetail"
      >
        <template v-slot:[`item.status`]="{ item }">
          <BusinessStatusChip :status="item.status" />
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon small :to="`/platform/businesses/${item.id}`">
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { fetchBusinesses } from '@/services/platform/businessService';
import BusinessStatusChip from '@/components/platform/BusinessStatusChip.vue';

export default {
  name: 'BusinessListView',
  components: { BusinessStatusChip },
  data() {
    return {
      loading: false,
      search: '',
      statusFilter: null,
      businesses: [],
      statusOptions: [
        { text: 'Activo', value: 'active' },
        { text: 'Suspendido', value: 'suspended' },
        { text: 'Pendiente', value: 'pending' },
        { text: 'Error provisioning', value: 'provisioning_failed' },
      ],
      headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'BD', value: 'dbName' },
        { text: 'Admin', value: 'adminEmail' },
        { text: 'Estado', value: 'status' },
        { text: 'Creado', value: 'createdAt' },
        { text: '', value: 'actions', sortable: false },
      ],
    };
  },
  created() {
    this.loadBusinesses();
  },
  methods: {
    async loadBusinesses() {
      this.loading = true;
      try {
        const params = {};
        if (this.search) params.search = this.search;
        if (this.statusFilter) params.status = this.statusFilter;
        this.businesses = await fetchBusinesses(params);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    goToDetail(item) {
      this.$router.push(`/platform/businesses/${item.id}`);
    },
    formatDate(value) {
      if (!value) return '-';
      return new Date(value).toLocaleString('es-MX');
    },
  },
};
</script>
